
import { useDispatch } from 'react-redux';
import { setFareMatrix, setLowestFareMatrix } from '../actionCreators/fareMatrix';

export function ResetFareMatrix() {
    const dispatch = useDispatch();

    dispatch(setFareMatrix(undefined));
    dispatch(setLowestFareMatrix([]));
}